var chopstickPopover = function() {
    // Initialize all popovers
    $('[data-toggle="popover"]').popover();
    if (typeof(Storage) !== "undefined") {
        if(window.sessionStorage.getItem("hideTips") !== "true") {
            $('[data-toggle="popover-show"]').popover('show');
        }
    }
    else {
        $('[data-toggle="popover-show"]').popover('show');
    }

     // Bind close popover event
     $('.js-popover-close').on('click', function(e){
         $(this).closest('.popover').popover('dispose');
         if(typeof(Storage) !== "undefined") {
             window.sessionStorage.setItem("hideTips","true")
         }
     });
};
